export default {
    interactivity: {
        afterClick: true,
        text: 'Click to interact'
    },
    fullScreenButton: {
        enabled: true,
        title: 'Display in full screen'
    },
    studioLinkButton: {
        enabled: true
    },
    componentSettings: {
        controls: {
            menu: false
        },
        tools: {
            measure: true,
            search: true,
            compare: true,
            filters: true
        },
        infoBox: {
            viewSwitch: false,
            defaultExpanded: true,
            share: true,
            bookmark: false,
            export: true,
            globalFilters: true
        },
        legend: {
            defaultExpanded: true
        }
    },
    theme: {
        logoSrc: null,
        colorPrimary: null
    }
};
